import Spinner from './Spinner';

const Loader = ({ loading, label, small }: { loading: boolean; label: string; small?: boolean }) => {
    if (!loading) return null;
    return (
        loading && (
            <>
                <Spinner color="buy" className="mx-2" />
                <span>{label}</span>
            </>
        )
    );
};
export default Loader;
